<form class="h-100 w-100" [formGroup]="form" [ngSwitch]="data['modal'].type" (ngSubmit)="send()">
  <div class="row mb-2">
    <h4 class="text-center vs-text-blue">
      {{data && data['id'] ? 'Edición ' : 'Creación '}} de {{data['modal'].item}}
    </h4>
  </div>
  <div class="row" *ngSwitchCase="1">
    <div class="col-12 vs-outline-editCard">
      <img class="given-img menu-img" [src]="file || data['img'] | safeDom" alt="img-benefit-slide v1"
        *ngIf="file || data['img']">
      <div class="btn-custom-file h-100 w-100">
        <label for="file-upload1" class="custom-file-upload">
          <mat-icon *ngIf="!file && !data['img']">image</mat-icon>
          <span class="my-2 text-center">{{data && data['id'] ? 'Cambiar ' : 'Agregar'}}
            imagen</span>
        </label>
        <input id="file-upload1" type="file" accept="image/*" (change)="imageUpload($event)" />
      </div>
    </div>
    <div class="col-12 my-1 px-xl-0">
      <mat-form-field class="example-full-width w-100" appearance="outline">
        <mat-label>Título</mat-label>
        <input formControlName="title" matInput placeholder="Ingresar título..." type="text">
      </mat-form-field>
    </div>
    <div class="col-12 mb-1 pl-xl-0">
      <mat-form-field class="example-full-width w-100" appearance="outline">
        <mat-label>Subtítulo</mat-label>
        <textarea #content formControlName="subTitle" [maxLength]="maxLength" matInput
          placeholder="Ingresar subTitulo..." type="text"></textarea>
        <mat-hint align="end">{{content.value?.length || 0}}/{{maxLength}}</mat-hint>
      </mat-form-field>
    </div>
    <div class="col-12 col-xl-6 mb-2 pr-xl-0">
      <mat-form-field class="example-full-width w-100" appearance="outline">
        <mat-label>Orden</mat-label>
        <input formControlName="orderId" matInput placeholder="Ingresar lugar de orden..." type="number">
      </mat-form-field>
    </div>
  </div>
  <div class="row" *ngSwitchCase="2">
    <div class="col-12 vs-outline-editCard">
      <img class="given-img menu-img" [src]="file || data['img'] | safeDom" alt="img-benefit-slide v2"
        *ngIf="file || data['img']">
      <div class="btn-custom-file h-100 w-100">
        <label for="file-upload2" class="custom-file-upload">
          <mat-icon *ngIf="!file && !data['img']">image</mat-icon>
          <span class="my-2 text-center">{{data && data['id'] ? 'Cambiar ' : 'Agregar'}}
            imagen</span>
        </label>
        <input id="file-upload2" type="file" accept="image/*" (change)="imageUpload($event)" />
      </div>
    </div>
    <div class="col-12 my-1 px-xl-0">
      <mat-form-field class="example-full-width w-100" appearance="outline">
        <mat-label>Título</mat-label>
        <input formControlName="title" matInput placeholder="Ingresar título..." type="text">
      </mat-form-field>
    </div>
    <div class="col-12 mb-2 px-xl-0">
      <mat-form-field class="example-full-width w-100" appearance="outline">
        <mat-label>Orden</mat-label>
        <input formControlName="orderId" matInput placeholder="Ingresar lugar de orden..." type="number">
      </mat-form-field>
    </div>
  </div>
  <div class="row" *ngSwitchCase="3">
    <div class="col-12 my-1 px-xl-0">
      <mat-form-field class="example-full-width w-100" appearance="outline">
        <mat-label>Texto</mat-label>
        <textarea #case3 formControlName="name" [maxLength]="maxLength" matInput placeholder="Ingresar texto..."
          type="text"></textarea>
        <mat-hint align="end">{{case3.value?.length || 0}}/{{maxLength}}</mat-hint>
      </mat-form-field>
    </div>
  </div>
  <div class="row" *ngSwitchCase="4">
    <div class="col-12 vs-outline-editCard">
      <img class="given-img menu-img" [src]="file || data['img'] | safeDom" alt="img-benefit-slide v3"
        *ngIf="file || data['img']">
      <div class="btn-custom-file h-100 w-100">
        <label for="file-upload4" class="custom-file-upload">
          <mat-icon *ngIf="!file && !data['img']">image</mat-icon>
          <span class="my-2 text-center">{{data && data['id'] ? 'Cambiar ' : 'Agregar'}}
            imagen</span>
        </label>
        <input id="file-upload4" type="file" accept="image/*" (change)="imageUpload($event)" />
      </div>
    </div>
    <div class="col-12 my-1 px-xl-0">
      <mat-form-field class="example-full-width w-100" appearance="outline">
        <mat-label>Texto</mat-label>
        <textarea #case4 [maxLength]="maxLength" formControlName="name" matInput placeholder="Ingresar texto..."
          type="text"></textarea>
        <mat-hint align="end">{{case4.value?.length || 0}}/{{maxLength}}</mat-hint>
      </mat-form-field>
    </div>
  </div>
  <div class="row" *ngSwitchCase="5">
    <div class="col-12 my-1 px-xl-0">
      <mat-form-field class="example-full-width w-100" appearance="outline">
        <mat-label>Título</mat-label>
        <input formControlName="title" matInput placeholder="Ingresar título..." type="text">
      </mat-form-field>
    </div>
    <div class="col-12 mb-1 px-xl-0">
      <mat-form-field class="example-full-width w-100" appearance="outline">
        <mat-label>Subtítulo</mat-label>
        <textarea #case5 [maxLength]="maxLength" formControlName="subTitle" matInput placeholder="Ingresar subTitulo..."
          type="text"></textarea>
        <mat-hint align="end">{{case5.value?.length || 0}}/{{maxLength}}</mat-hint>
      </mat-form-field>
    </div>
  </div>
  <div class="row" *ngSwitchCase="6">
    <div class="col-12 my-1 px-xl-0">
      <mat-form-field class="example-full-width w-100" appearance="outline">
        <mat-label>Título</mat-label>
        <input formControlName="title" matInput placeholder="Ingresar título..." type="text">
      </mat-form-field>
    </div>
    <div class="col-12 mb-1 px-xl-0">
      <mat-form-field class="example-full-width w-100" appearance="outline">
        <mat-label>Subtítulo</mat-label>
        <textarea #case6 [maxLength]="maxLength" formControlName="subTitle" matInput placeholder="Ingresar subTitulo..."
          type="text"></textarea>
        <mat-hint align="end">{{case6.value?.length || 0}}/{{maxLength}}</mat-hint>
      </mat-form-field>
    </div>
    <div class="col-12 mb-2 px-xl-0">
      <mat-form-field class="example-full-width w-100" appearance="outline">
        <mat-label>Orden</mat-label>
        <input formControlName="orderId" matInput placeholder="Ingresar lugar de orden..." type="number">
      </mat-form-field>
    </div>
  </div>
  <div class="row" *ngSwitchCase="7">
    <div class="col-12 vs-outline-editCard">
      <img class="given-img menu-img" [src]="file || data['img'] || data['img64Link'] | safeDom"
        alt="img-benefit-slide v1" *ngIf="file || data['img']">
      <div class="btn-custom-file h-100 w-100">
        <label for="file-upload7" class="custom-file-upload">
          <mat-icon *ngIf="!file && !data['img']">image</mat-icon>
          <span class="my-2 text-center">{{data && data['id'] ? 'Cambiar ' : 'Agregar'}}
            archivo</span>
        </label>
        <input id="file-upload7" type="file" accept="image/*, .pdf, .doc, .docx, .xls, .xlsx"
          (change)="imageUpload($event)" />
      </div>
    </div>
  </div>
  <div class="row" *ngSwitchCase="8">
    <div class="col-12 my-1 px-xl-0 dv-richText">
      <label class="example-full-width w-100">Texto</label>
      <quill-editor placeholder="Ingresar texto..." formControlName="name" [maxLength]="maxLength">
        <div quill-editor-toolbar class="w-100">
          <span class="ql-formats">
            <button class="ql-bold" [title]="'Bold'"></button>
          </span>
          <span class="ql-formats">
            <select class="ql-align" [title]="'Justificación de texto'">
              <option selected></option>
              <option value="center"></option>
              <option value="right"></option>
              <option value="justify"></option>
            </select>
          </span>
          <span class="ql-formats">
            <button class="ql-list" value="bullet"></button>
          </span>
        </div>
      </quill-editor>
      <mat-error *ngIf="form.value.name.length > maxLength">Máximo de caracteres es de {{maxLength}}!
      </mat-error>
      <mat-hint align="end"> {{form.value.name.length}} / {{maxLength}} caracteres!</mat-hint>
    </div>
  </div>
  <div class="row justify-content-between" *ngSwitchCase="9">
    <div class="col-3 vs-outline-editCard mx-1">
      <img class="given-img menu-img" [src]="file || data['img'] | safeDom" alt="img-benefit-slide v1"
        *ngIf="file || data['img']">
      <div class="btn-custom-file h-100 w-100">
        <label for="file-upload8" class="custom-file-upload">
          <mat-icon *ngIf="!file && !data['img']">image</mat-icon>
          <span class="my-2 text-center">{{data && data['id'] ? 'Cambiar ' : 'Agregar'}}
            archivo</span>
        </label>
        <input id="file-upload8" type="file" accept="image/*, .pdf, .doc, .docx, .xls, .xlsx"
          (change)="imageUpload($event, 1)" />
      </div>
    </div>
    <div class="col-3 vs-outline-editCard mx-1">
      <img class="given-img menu-img" [src]="file2 || data['img2'] | safeDom" alt="img-benefit-slide v1"
        *ngIf="file2 || data['img2']">
      <div class="btn-custom-file h-100 w-100">
        <label for="file-upload9" class="custom-file-upload">
          <mat-icon *ngIf="!file2 && !data['img2']">image</mat-icon>
          <span class="my-2 text-center">{{data && data['id'] ? 'Cambiar ' : 'Agregar'}}
            archivo</span>
        </label>
        <input id="file-upload9" type="file" accept="image/*, .pdf, .doc, .docx, .xls, .xlsx"
          (change)="imageUpload($event, 2)" />
      </div>
      <button *ngIf="file2 || data['img2']" type="button" class="vs-btn-crud" (click)="clearImage(2)">
        <mat-icon>delete</mat-icon>
      </button>
    </div>
    <div class="col-3 vs-outline-editCard mx-1">
      <img class="given-img menu-img" [src]="file3 || data['img3'] | safeDom" alt="img-benefit-slide v1"
        *ngIf="file3 || data['img3']">
      <div class="btn-custom-file h-100 w-100">
        <label for="file-upload10" class="custom-file-upload">
          <mat-icon *ngIf="!file3 && !data['img3']">image</mat-icon>
          <span class="my-2 text-center">{{data && data['id'] ? 'Cambiar ' : 'Agregar'}}
            archivo</span>
        </label>
        <input id="file-upload10" type="file" accept="image/*, .pdf, .doc, .docx, .xls, .xlsx"
          (change)="imageUpload($event, 3)" />
      </div>
      <button *ngIf="file3 || data['img3']" type="button" class="vs-btn-crud" (click)="clearImage(3)">
        <mat-icon>delete</mat-icon>
      </button>
    </div>
  </div>
  <div class="row" *ngSwitchCase="10">
    <div class="col-12 vs-outline-editCard">
      <img class="given-img menu-img" [src]="file || data['img'] | safeDom" alt="img-benefit-slide v1"
        *ngIf="file || data['img']">
      <div class="btn-custom-file h-100 w-100">
        <label for="file-upload10" class="custom-file-upload">
          <mat-icon *ngIf="!file && !data['img']">image</mat-icon>
          <span class="my-2 text-center">{{data && data['id'] ? 'Cambiar ' : 'Agregar'}}
            imagen</span>
        </label>
        <input id="file-upload10" type="file" accept="image/*" (change)="imageUpload($event)" />
      </div>
    </div>
    <div class="col-12 my-1 px-xl-0">
      <mat-form-field class="example-full-width w-100" appearance="outline">
        <mat-label>Título</mat-label>
        <input formControlName="title" matInput placeholder="Ingresar título..." type="text">
      </mat-form-field>
    </div>

    <div class="col-12 mb-1 px-xl-0">
      <div class="mb-3">
        <label class="example-full-width w-100">Subtítulo</label>
        <quill-editor placeholder="Ingresar texto..." formControlName="subTitle" [maxLength]="maxLength">
          <div quill-editor-toolbar class="w-100">
            <span class="ql-formats">
              <button class="ql-bold" [title]="'Bold'"></button>
            </span>
            <span class="ql-formats">
              <select class="ql-align" [title]="'Justificación de texto'">
                <option selected></option>
                <option value="center"></option>
                <option value="right"></option>
                <option value="justify"></option>
              </select>
            </span>
            <span class="ql-formats">
              <button class="ql-list" value="bullet"></button>
            </span>
          </div>
        </quill-editor>
        <mat-error *ngIf="form.value.subTitle.length > maxLength">Máximo de caracteres es de {{maxLength}}!
        </mat-error>
        <mat-hint align="end"> {{form.value.subTitle.length}} / {{maxLength}} caracteres!</mat-hint>
      </div>
    </div>
    <div class="col-12 mb-2 px-xl-0">
      <mat-form-field class="example-full-width w-100" appearance="outline">
        <mat-label>Orden</mat-label>
        <input formControlName="orderId" matInput placeholder="Ingresar lugar de orden..." type="number">
      </mat-form-field>
    </div>
  </div>

  <div class="row" *ngSwitchCase="11">
    <div class="col-12 my-1 px-xl-0">
      <mat-form-field class="example-full-width w-100" appearance="outline">
        <mat-label>Título</mat-label>
        <input formControlName="name" matInput placeholder="Ingresar título..." type="text">
      </mat-form-field>
    </div>
    <div class="col-12 mb-1 px-xl-0">
      <mat-form-field class="example-full-width w-100" appearance="outline">
        <mat-label>Link</mat-label>
        <input formControlName="img" matInput placeholder="Ingresar la URL del PDF..." type="text">
      </mat-form-field>
    </div>
  </div>

  <div class="row" *ngSwitchCase="12">
    <div class="col-12 vs-outline-editCard">
      <img class="given-img menu-img" [src]="file || data['img'] | safeDom" alt="img-benefit-slide v2"
        *ngIf="file || data['img']">
      <div class="btn-custom-file h-100 w-100">
        <label for="file-upload2" class="custom-file-upload">
          <mat-icon *ngIf="!file && !data['img']">image</mat-icon>
          <span class="my-2 text-center">{{data && data['id'] ? 'Cambiar ' : 'Agregar'}}
            imagen</span>
        </label>
        <input id="file-upload2" type="file" accept="image/*" (change)="imageUpload($event)" />
      </div>
    </div>
    <div class="col-12 my-1 px-xl-0">
      <mat-form-field class="example-full-width w-100" appearance="outline">
        <mat-label>Título</mat-label>
        <input formControlName="title" matInput placeholder="Ingresar título..." type="text">
      </mat-form-field>
    </div>
    <div class="col-12 my-1 px-xl-0">
      <mat-form-field class="example-full-width w-100" appearance="outline">
        <mat-label>Subtítulo</mat-label>
        <input formControlName="subTitle" matInput placeholder="Ingresar subTitulo..." type="text">
      </mat-form-field>
    </div>
    <div class="col-12 my-1 px-xl-0">
      <mat-form-field class="example-full-width w-100" appearance="outline">
        <mat-label>Subtítulo 2</mat-label>
        <input formControlName="subTitle2" matInput placeholder="Ingresar subTitulo 2..." type="text">
      </mat-form-field>
    </div>
    <div class="col-12 mb-2 px-xl-0">
      <mat-form-field class="example-full-width w-100" appearance="outline">
        <mat-label>Orden</mat-label>
        <input formControlName="orderId" matInput placeholder="Ingresar lugar de orden..." type="number">
      </mat-form-field>
    </div>
  </div>

  <button type="submit" class="vs-btn-blue"
    [disabled]="form.invalid || ([10].includes(data['modal'].type) && form.value.subTitle.length > maxLength)">
    {{allRecords === 0 ? (data && data['id'] ? 'Edición ' : 'Creación ') : 'Reemplazo '}}
    de {{data['modal'].item}}
  </button>
</form>